<template>
  <v-chip :color="computedColor" dark small>
    {{ data.status | requestStatus }}
  </v-chip>
</template>

<script>
export default {
  name: "statusComponent",

  props: {
    data: Object,
    name: String
  },

  computed: {
    computedColor() {
      let color = '';
      switch (this.data.status) {
        case 'pending':
          color = 'warning'
          break;
        case 'accept':
          color = 'success'
          break;
        case 'reject':
          color = '#f13030'
          break;
      }

      return color
    }
  }
}
</script>

<style scoped>

</style>